import {useMutation} from '@tanstack/react-query';
import {DeleteRefundProcedureParams} from 'domain/usecases/private/refund/request/delete-procedure';
import {deleteProcedure} from '../services/deleteProcedure';

export const useDeleteProcedureMutation = () =>
	useMutation({
		mutationFn: (params: DeleteRefundProcedureParams) => deleteProcedure(params),
		retry: 1,
	});
